module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/art-desktop.7307a08f.png";